export type UserAttachment = {
  key: string;
  fileName: string;
  contentType?: string;
  size: number;
  url: string;
  createdAt?: Date | string;
};

export type CommercialStatus =
  | "UNQUALIFIED"
  | "LEAD"
  | "QUALIFIED_LEAD"
  | "OPPORTUNITY";

export const COMMERCIAL_STATUS_META: Record<
  CommercialStatus,
  { label: string; className: string }
> = {
  UNQUALIFIED: { label: "Sem qualificação", className: "badge" },
  LEAD: { label: "Lead", className: "badge badge-info" },
  QUALIFIED_LEAD: {
    label: "Lead qualificado",
    className: "badge badge-warning",
  },
  OPPORTUNITY: { label: "Oportunidade", className: "badge badge-success" },
};

export type User = {
  id?: string;
  userName: string;
  userPhone: string;
  countryCode: string;
  dialCode: string;
  additionalInfo?: string;
  birthDate?: Date | string;
  email?: string;
  zipCode?: string;
  addressLine?: string;
  addressNumber?: string;
  complement?: string;
  neighborhood?: string;
  city?: string;
  country?: string;
  acceptsEmailCommunications?: boolean;
  contactConsent?: {
    status: "PENDING" | "GRANTED" | "DENIED";
    requestedAt?: string;
    respondedAt?: string;
  };
  attachments?: UserAttachment[];
  color?: string;
  aiContext?: Record<string, string>;
  createdAt?: Date;
  updatedAt?: Date;
  commercialStatus: CommercialStatus;
};
